import React from 'react';
export function useSlideExit(duration = 280, resetKey, opts) {
    const enterOnMount = opts?.enterOnMount !== undefined ? !!opts.enterOnMount : true;
    const animateOnReset = opts?.animateOnReset !== undefined ? !!opts.animateOnReset : true;
    const [exiting, setExiting] = React.useState(false);
    const [entered, setEntered] = React.useState(enterOnMount ? false : true);
    const startExit = React.useCallback((after) => {
        if (exiting)
            return;
        try {
            console.log('[useSlideExit] startExit -> schedule after', duration, 'ms');
        }
        catch { }
        setExiting(true);
        window.setTimeout(() => {
            try {
                console.log('[useSlideExit] after timeout, calling callback');
            }
            catch { }
            after();
        }, duration);
    }, [exiting, duration]);
    React.useEffect(() => {
        // slide-in on mount (optional)
        try {
            console.log('[useSlideExit] mount');
        }
        catch { }
        if (!enterOnMount)
            return;
        const id = requestAnimationFrame(() => {
            try {
                console.log('[useSlideExit] enter -> setEntered(true)');
            }
            catch { }
            setEntered(true);
        });
        return () => cancelAnimationFrame(id);
    }, [enterOnMount]);
    React.useEffect(() => { try {
        console.log('[useSlideExit] state change', { entered, exiting, duration });
    }
    catch { } }, [entered, exiting, duration]);
    // Allow external reset of animation states (e.g., when a view is re-entered)
    React.useEffect(() => {
        if (typeof resetKey === 'undefined')
            return;
        try {
            console.log('[useSlideExit] resetKey changed -> reset animation state');
        }
        catch { }
        setExiting(false);
        if (!animateOnReset) {
            setEntered(true);
            return;
        }
        setEntered(false);
        const id = requestAnimationFrame(() => setEntered(true));
        return () => cancelAnimationFrame(id);
    }, [resetKey, animateOnReset]);
    const containerStyle = React.useMemo(() => ({
        position: 'relative',
        height: '100%',
        background: 'var(--app-bg-primary)',
    }), []);
    const underlayStyle = React.useMemo(() => ({
        position: 'absolute',
        inset: 0,
        background: 'var(--app-bg-primary)',
    }), []);
    const panelStyle = React.useMemo(() => ({
        position: 'absolute',
        inset: 0,
        background: 'var(--app-bg-primary)',
        display: 'flex',
        flexDirection: 'column',
        transform: exiting ? 'translateX(100%)' : (entered ? 'translateX(0)' : 'translateX(100%)'),
        transition: `transform ${duration}ms cubic-bezier(.21,.61,.35,1)`,
        willChange: 'transform',
        pointerEvents: exiting ? 'none' : 'auto',
    }), [exiting, entered, duration]);
    return { exiting, startExit, containerStyle, underlayStyle, panelStyle };
}
